<template>
  <div class="row justify-content-center">
    <div class="col-md-11">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Visualizar Pergunta do Questionário</h4>

          <div class="row">
            <div class="col-md-12">
              <label>Pergunta exibida no totem</label>
              <input
                type="text"
                class="form-control"
                v-model="pergunta.enunciado"
                disabled
              />
            </div>
            <div class="col-md-4 mt-3">
              <label>Respostas permitidas</label>
              <input
                type="text"
                class="form-control"
                :value="pergunta.selecao === 'unica' ? 'Uma resposta' : 'Várias respostas'"
                disabled
              />
            </div>
            <div class="col-md-2 mt-3">
              <label>Ordem</label>
              <input type="number" class="form-control" v-model="pergunta.ordem" disabled />
            </div>
            <div class="col-md-3 mt-3">
              <br />
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="perguntaObrigatoriaView"
                  v-model="pergunta.obrigatoria"
                  disabled
                />
                <label class="custom-control-label" for="perguntaObrigatoriaView">
                  Resposta obrigatória
                </label>
              </div>
            </div>
            <div class="col-md-3 mt-3">
              <br />
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="perguntaAtivaView"
                  v-model="pergunta.ativo"
                  disabled
                />
                <label class="custom-control-label" for="perguntaAtivaView">
                  Ativa
                </label>
              </div>
            </div>

            <div class="col-md-12 mt-4">
              <label>Alternativas</label>
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th width="34%">Texto</th>
                    <th width="10%">Ordem</th>
                    <th width="14%">Ícone</th>
                    <th width="30%" v-if="temLinhaCuidado">
                      {{ pergunta.usa_grupos ? "Grupo" : "Linha de cuidado sugerida" }}
                    </th>
                    <th width="12%">Ativa</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="alternativa in pergunta.alternativas" :key="alternativa.id">
                    <td>{{ alternativa.nome }}</td>
                    <td>{{ alternativa.ordem }}</td>
                    <td>
                      <img
                        v-if="alternativa.icone_url"
                        :src="alternativa.icone_url"
                        height="28"
                      />
                      <span v-else class="text-muted">—</span>
                    </td>
                    <td v-if="temLinhaCuidado">
                      {{ descricaoDaSugestao(alternativa) }}
                    </td>
                    <td>{{ alternativa.ativo ? "Sim" : "Não" }}</td>
                  </tr>
                  <tr v-if="!pergunta.alternativas.length">
                    <td :colspan="temLinhaCuidado ? 5 : 4" class="text-center text-muted">
                      Nenhuma alternativa cadastrada.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col-md-12 mt-2">
              <label>Demandas que fazem esta pergunta</label>
              <input
                type="text"
                class="form-control"
                :value="pergunta.botoes.map((botao) => botao.nome).join(', ')"
                disabled
                v-if="pergunta.botoes.length"
              />
              <span v-else class="text-muted d-block">
                Nenhuma demanda usa esta pergunta.
              </span>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-12 text-right">
              <hr />
              <button
                class="btn btn-back"
                @click="$router.push('/questionario_perguntas')"
              >
                <i class="fa fa-arrow-left"></i> Voltar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pergunta: {
        enunciado: "",
        selecao: "multipla",
        obrigatoria: true,
        ativo: true,
        ordem: 0,
        alternativas: [],
        grupos: [],
        botoes: [],
        usa_grupos: false,
      },
    };
  },
  computed: {
    temLinhaCuidado() {
      if (this.pergunta.usa_grupos) {
        return this.pergunta.grupos.some((grupo) => grupo.linha_cuidado_id);
      }

      return this.pergunta.alternativas.some((alternativa) => alternativa.linha_cuidado_id);
    },
  },
  methods: {
    descricaoDaSugestao: function (alternativa) {
      const self = this;

      if (!self.pergunta.usa_grupos) {
        return alternativa.linha_cuidado ? alternativa.linha_cuidado.nome : "—";
      }

      const grupo = self.pergunta.grupos.find(
        (item) => item.id === alternativa.questionario_grupo_id
      );

      if (!grupo) {
        return "—";
      }

      const linha = grupo.linha_cuidado ? grupo.linha_cuidado.nome : "sem linha";

      return grupo.nome + " (" + linha + ", mínimo " + grupo.minimo_respostas + ")";
    },
    getPergunta: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "questionario_perguntas/" +
        id +
        "?with[]=alternativas&with[]=alternativas.linhaCuidado&with[]=grupos&with[]=grupos.linhaCuidado&with[]=botoes";

      axios
        .get(api)
        .then((response) => {
          const registro = response.data.data[0];

          self.pergunta = {
            enunciado: registro.enunciado,
            selecao: registro.selecao,
            obrigatoria: !!registro.obrigatoria,
            ativo: !!registro.ativo,
            ordem: registro.ordem,
            alternativas: registro.alternativas || [],
            grupos: registro.grupos || [],
            botoes: registro.botoes || [],
            usa_grupos: !!registro.usa_grupos,
          };
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    this.getPergunta(this.$route.params.id);
  },
};
</script>
